import { render, staticRenderFns } from "./StakeModal.vue?vue&type=template&id=2b04207e&scoped=true&"
import script from "./StakeModal.vue?vue&type=script&lang=js&"
export * from "./StakeModal.vue?vue&type=script&lang=js&"
import style0 from "./StakeModal.vue?vue&type=style&index=0&id=2b04207e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b04207e",
  null
  
)

export default component.exports